import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as DangerIcon } from 'assets/icons/danger.svg';
import clsx from 'clsx';
import Button from 'components/Button/Button';
import Toggle from 'components/Toggle/Toggle';
import Tooltip from 'components/Tooltip/Tooltip';
import { GEO_TOGGLE_NAME } from 'constants/general';
import { BUTTON_VARIANT } from 'constants/interfaces';
import { getTextDate } from 'utils/formattedData';

import Select from '../Select/Select';

import type IOption from '../MappingModal/interfaces/IOption';
import type ITitleTableWrapper from './interfaces/ITitleTableWrapper';

import styles from './scss/TitleTableWrapper.module.scss';

function TitleTableWrapper({
  title,
  hint,
  buttonTitle,
  onButtonClick,
  showButton = false,
  buttonClassName,
  titleCounter,
  max,
  count,
  disableButton,
  tooltipTitle,
  valueToggle,
  onChangeToggle,
  labelToggle,
  classNameTitle,
  classNameHint,
  onUpdate,
  onBtnClickPrev,
  prevTitleBtn,
  disableIconButton,
  tooltipTitleUpdate,
  titleUpdateBtn,
  vcOptions,
  valueSelector,
  setValueSelector,
  IROIdentification,
  dateUpdated,
}: ITitleTableWrapper) {
  const { t } = useTranslation();
  const [options, setOptions] = useState<IOption[]>([]);

  useEffect(() => {
    if (vcOptions && vcOptions.length > 0) {
      setOptions([{ label: 'All', value: '' }, ...vcOptions]);
    }
  }, [vcOptions]);

  return (
    <div className={styles.titleTableWrapper}>
      <div className={styles.titleWrapper}>
        <div className={styles.titleContainer}>
          <span className={`${clsx(styles.titleContent, { [styles.titleWithHint]: hint })} ${classNameTitle}`}>
            {title}
          </span>
          {hint ? <span className={`${styles.hint} ${classNameHint}`}>{hint}</span> : null}
        </div>
        {onChangeToggle ? (
          <div className={styles.toggleWrapper}>
            <Toggle
              value={GEO_TOGGLE_NAME}
              checked={!!valueToggle}
              name={GEO_TOGGLE_NAME}
              onChange={onChangeToggle ? (e) => onChangeToggle(e.target.checked) : () => {}}
            />
            {labelToggle ? <span className={styles.labelToggle}>{labelToggle}</span> : null}
          </div>
        ) : null}
      </div>
      <div className={styles.actionsWrapper}>
        {options.length > 0 && !IROIdentification && setValueSelector ? (
          <Select
            classNameMenu={styles.selectVC}
            className={styles.template}
            placeholder={t('common.selectVC')}
            options={options}
            value={options.find((option) => option.value === valueSelector) || null}
            onChange={(selectedOption) => setValueSelector((selectedOption as IOption)?.value || '')}
            menuPosition="absolute"
            maxMenuHeight={200}
          />
        ) : null}
        {dateUpdated ? (
          <span className={styles.titleDate}>
            {`${t('materialityAssessment.lastUpdated')}`}
            {' '}
            {getTextDate(dateUpdated)}
          </span>
        ) : null}
        {onUpdate ? (
          <Tooltip
            hint={tooltipTitleUpdate || ''}
            className={styles.tooltip}
          >
            <Button
              title={titleUpdateBtn || t('common.refreshData')}
              variant={BUTTON_VARIANT.cancel}
              className={styles.prevButton}
              disabled={disableIconButton}
              startIcon={<DangerIcon />}
              onClick={onUpdate}
            />
          </Tooltip>

        ) : null}
        {onBtnClickPrev && prevTitleBtn ? (
          <Button
            title={prevTitleBtn}
            onClick={onBtnClickPrev}
            className={styles.button}
          />
        ) : null}
        {showButton && buttonTitle && onButtonClick ? (
          <div className={styles.buttonWrapper}>
            {disableButton ? (
              <Tooltip
                hint={tooltipTitle || ''}
                className={styles.tooltip}
              >
                <Button
                  title={buttonTitle}
                  onClick={onButtonClick}
                  className={styles.button}
                  disabled={disableButton}
                />
              </Tooltip>
            ) : (
              <Button
                title={buttonTitle}
                onClick={onButtonClick}
                className={buttonClassName}
              />
            )}

            {titleCounter && max && count ? (
              <span className={styles.titleCounter}>
                {`${titleCounter} ${count}/${max}`}
              </span>
            ) : null}
          </div>
        ) : null}
      </div>

    </div>
  );
}

export default TitleTableWrapper;
